/* eslint-disable default-param-last */
/**
 * @description Reducer sobre os alertas do sistema
 * @author Bene Lemuel Dantas Gondim
 * @file alertasReducer.js
 *
 * @license Copyright (c) 2020 SIGEP DIGETI ITEP/RN
 */
import * as actionTypes from 'actions'

// Estado inicial da sessão no redux
const initialState = {
  status: null,
  innerErrorMessage: '',
  variant: '',
  message: '',
}

const alertasReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ALERTA_USUARIO_SEM_PERMISSAO_ERROR: {
      return {
        ...state,
        status: action.status,
        innerErrorMessage: action.innerErrorMessage,
        variant: action.variant,
        message: action.message,
      }
    }

    case actionTypes.ALERTA_SALVO_SUCESSO: {
      return {
        ...state,
        status: action.status,
        innerErrorMessage: action.innerErrorMessage,
        variant: action.variant,
        message: action.message,
      }
    }

    case actionTypes.ALERTA_ERRO_NO_FORMULARIO_ERROR: {
      return {
        ...state,
        status: action.status,
        innerErrorMessage: action.innerErrorMessage,
        variant: action.variant,
        message: action.message,
      }
    }

    case actionTypes.ALERTA_CAMINHO_NAO_ENCONTRADO: {
      return {
        ...state,
        status: action.status,
        innerErrorMessage: action.innerErrorMessage,
        variant: action.variant,
        message: action.message,
      }
    }

    case actionTypes.ALERTA_ERRO_DE_APLICACAO: {
      return {
        ...state,
        status: action.status,
        innerErrorMessage: action.innerErrorMessage,
        variant: action.variant,
        message: action.message,
      }
    }

    case actionTypes.ALERTA_STATUS_DESCONHECIDO: {
      return {
        ...state,
        status: action.status,
        innerErrorMessage: action.innerErrorMessage,
        variant: action.variant,
        message: action.message,
      }
    }

    case actionTypes.ALERTA_CREDENCIAIS_INVALIDAS: {
      return {
        ...state,
        status: action.status,
        innerErrorMessage: action.innerErrorMessage,
        variant: action.variant,
        message: action.message,
      }
    }

    default: {
      return state
    }
  }
}

export default alertasReducer
